module.exports = __webpack_public_path__ + "static/media/1.cc463dce.jpg";